<template>
	<div
		class="team_member"
		v-on:mouseover="mouseover"
		v-on:mouseleave="mouseleave"
	>
		<img
			v-if="profile_picture"
			class="background__image"
			:src="profile_picture"
			:alt="staff_name"
		/>

		<transition name="slide-fade">
			<div v-if="show" class="overlay"></div>
		</transition>

		<transition name="zoom">
			<div v-if="show" class="title_category">
				<p class="staff_name" v-text="staff_name"></p>
				<p class="staff_role" v-text="staff_role"></p>
				<ul class="social">
					<li>
						<a :href="linked_in" target="_blank"
							><img :src="linked_in_icon" alt="Linked In"
						/></a>
					</li>
					<li>
						<a :href="'mailto:' + email"
							><img :src="email_icon" alt="Linked In"
						/></a>
					</li>
				</ul>
			</div>
		</transition>
	</div>
</template>

<script>
import linked_in_image from '../../images/LI_ls.svg';
import email_image from '../../images/Mail_ls.svg';

export default {
	data() {
		return {
			show: false,
		};
	},

	props: {
		staff_name: {},
		staff_role: {},
		linked_in: {},
		email: {},
		profile_picture: {},
		linked_in_icon: {
			default: linked_in_image,
		},
		email_icon: {
			default: email_image,
		},
	},

	computed: {},

	watch: {},

	methods: {
		mouseover: function () {
			this.show = true;
		},
		mouseleave: function () {
			this.show = false;
		},
	},

	components: {},

	created() {},
	mounted() {},
};
</script>

<style lang="scss" scoped>
@import '../../styles/common/variables';

.team_member {
	text-decoration: none;
	min-height: 400px;
	background: lighten($edc-charcoal, 20);
	display: flex;
	flex-direction: column;
	justify-content: flex-end;
	align-items: center;
	position: relative;
	border-radius: 5px;
	overflow: hidden;

	@media (max-width: $md) {
		min-height: 300px;
	}

	&:hover {
		.background__image {
			transition: all 0.2s ease;
			transform: scale(1.1);
		}
	}

	@media (max-width: $md) {
		grid-column: span 10;
	}

	.background__image {
		width: 100%;
		height: 100%;
		z-index: 0;
		transition: all 0.2s ease;
		transform: scale(1);
		object-fit: cover;
		object-position: top;
	}

	> img {
		position: absolute;
		height: 100%;
		top: 0;
	}

	.title_category {
		position: relative;
		z-index: 20;
		width: calc(100% - 4rem);
		transition: all 0.2s ease;
		opacity: 1;
		transform: translateY(0px);
		z-index: 2;
		margin-bottom: 2rem;

		p {
			margin: 0;
			color: white;
		}

		.staff_name {
			transition-delay: 0.2s;
			transition: 0.2s ease all;
			transform: translateY(0px);
			font-weight: bold;
			margin-bottom: 0.5rem;
		}

		.staff_role {
			transition-delay: 0.4s;
			transition: 0.2s ease all;
			transform: translateY(0px);
			margin-bottom: 1rem;
		}

		.social {
			transition-delay: 0.6s;
			transition: 0.2s ease all;
			transform: translateY(0px);
			list-style: none;
			padding: 0;
			margin: 1rem 0 0;
			display: flex;
			flex-direction: row;
			flex-wrap: wrap;

			li {
				margin-right: 0.5rem;

				a {
					text-decoration: none;
					background: none;

					&:hover {
						background: none;
					}

					img {
						height: 30px;
					}
				}
			}
		}

		transition-delay: 0.6s;
	}

	.overlay {
		background: rgb(0, 0, 0.3);
		background: linear-gradient(
			0deg,
			rgba(0, 0, 0, 0.3981967787114846) 10%,
			rgba(0, 0, 0, 0) 55%
		);
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		align-items: flex-start;
		width: 100%;
		height: 100%;
		position: absolute;
		top: 0;
		transition: 0.2s ease all;
		z-index: 1;

		&.hovered {
			background: rgba(0, 0, 0, 0.3);
		}
	}
}

.zoom-enter-active {
	transition: all 0.5s cubic-bezier(1, 0.5, 0.8, 1);
}

.zoom-leave-active {
	transition: all 0.5s cubic-bezier(1, 0.5, 0.8, 1);
	// transition-delay: .4s;
}

.zoom-enter,
.zoom-leave-to {
	opacity: 0;
	transform: translateY(50px);

	.staff_name {
		transform: translateY(50px);
		opacity: 0;
	}

	.staff_role {
		transform: translateY(50px);
		opacity: 0;
	}

	.social {
		transform: translateY(50px);
		opacity: 0;
	}
}

.slide-fade-enter-active {
	transition: opacity 0.2s ease;
	transition-delay: 0.3s;
}

.slide-fade-leave-active {
	transition: opacity 0.2s cubic-bezier(1, 0.5, 0.8, 1);
	// transition-delay: .4s;
}

.slide-fade-enter,
.slide-fade-leave-to {
	opacity: 0;
}

/* write SCSS here */
</style>



// WEBPACK FOOTER //
// resources/assets/scripts/vue/TeamListingItem.vue